import { queryOptions } from "@tanstack/react-query";

import * as api from "@/api/api";
import { Entity } from "@/types/proto/exabel/id/id_graph_messages";

export const entityQueryOptions = (entityResourceName: string | undefined) =>
  queryOptions({
    queryKey: ["entity", entityResourceName],
    enabled: !!entityResourceName,
    staleTime: Infinity,
    queryFn: () => api.get<Entity>(`v1/${entityResourceName}`),
  });
